import { Setting, Edit, User, Document } from "react-iconly";
import Container from "@/components/layout/Container";
import PageTitleBox from "@/components/common/PageTitleBox";
import ServiceSteps from "./ServiceStep";
import ServiceSection from "./ServiceSection";

const ServiceAicc = () => {
  const steps = [
    {
      number: 1,
      icon: (() => {
        const IconComponent = Setting as any;
        return <IconComponent set="bulk" size={28} primaryColor="#d97706" />;
      })(),
      title: "도입 사례 보기",
      description: "주요 기능 미리보기 및\nUI 스타일 체험하기",
      active: true,
    },
    {
      number: 2,
      icon: (() => {
        const IconComponent = User as any;
        return <IconComponent set="bulk" size={28} primaryColor="#d97706" />;
      })(),
      title: "서비스 이용 신청",
      description: "간편 폼 작성을 통한\n기본 정보 등록 및 필수 서류 제출",
      active: false,
    },
    {
      number: 3,
      icon: (() => {
        const IconComponent = Edit as any;
        return <IconComponent set="bulk" size={28} primaryColor="#d97706" />;
      })(),
      title: "온라인 계약 체결",
      description: "추가 서류 제출,\n정식 계약서 작성 후 최종 계약",
      active: false,
    },
  ];

  return (
    <Container>
      <main className="py-[60px]">
        <div className="bg-[linear-gradient(to_bottom,rgb(251,251,251)_11%,#F9F3EE_100%)] rounded-xl pb-32 mb-24">
          {/* Hero Section */}
          <PageTitleBox
            badge="문자콜센터 서비스 도입"
            badgeColor="orange"
            title={
              <>
                쉽고 빠른 지능형 상담 서비스
                <br />
                간단한 코드 삽입만으로 <span className="text-[#d97706]">문자콜센터</span>를
                시작하세요
              </>
            }
            subtitle="일일이 받던 문의 전화는 끝, 015 번호로 오는 전화를 텍스트로 바로 확인하세요"
            showSeparator={false}
          />

          {/* Steps */}
          <ServiceSteps steps={steps} titleColor="text-[#1a1a1a]" iconBackground="bg-[#fff3e0]" />
        </div>

        {/* Section 1: 서비스 데모 체험 */}
        <ServiceSection
          badge="도입 사례 보기"
          title="서비스 실제 구동 화면과 UI 스타일을 미리 경험"
          icon={<Document set="bulk" size={32} primaryColor="#e91e63" />}
          iconBgColor="bg-white"
          buttonText="서비스 데모 체험하기"
          buttonLink="#"
          isExternalLink={true}
          bgColor="bg-[#F9F7ED]"
          description={
            <>
              <p className="text-[1.55rem] text-[#333333] leading-relaxed">
                스탠다드네트웍스 웹사이트에 실제 적용된 서비스를 통해,
              </p>
              <p className="text-[1.55rem] text-[#333333] mb-3 leading-relaxed">
                도입 후의 완성도를{" "}
                <strong className="font-semibold">미리 확인하고 직접 체감</strong>해 보실 수
                있습니다.
              </p>
              <p className="text-[1.35rem] text-[#4361ee] font-medium">
                도입 시 코드 수정을 통해 세부 스타일 커스텀이 가능합니다.
              </p>
            </>
          }
        />

        {/* Section 2: 서비스 이용 신청 */}
        <ServiceSection
          badge="서비스 이용 신청"
          title="이용 신청 후 사이트로 이동하여 실사용 코드를 확인"
          icon={<User set="bulk" size={32} primaryColor="#ff9800" />}
          iconBgColor="bg-white"
          buttonText="서비스 이용 신청하기"
          buttonLink="/service/submit?type=aicc"
          bgColor="bg-[#F0F9ED]"
          description={
            <>
              <p className="text-[1.55rem] text-[#333333] leading-relaxed">
                <strong className="font-semibold">개인 계정</strong>은 서비스 사이트 이동 후 즉시
                이용 가능하며,
              </p>
              <p className="text-[1.55rem] text-[#333333] mb-3 leading-relaxed">
                <strong className="font-semibold">기업 계정</strong>은 안전한 운영을 위한 서류 승인
                절차 완료 후 정식 이용이 가능합니다.
              </p>
              <p className="text-[1.35rem] text-[#4361ee] font-medium">
                기업 계정의 경우 서비스 신청 후 승인까지 영업일 기준 최대 1~2일이 소요될 수
                있습니다.
              </p>
            </>
          }
        />
      </main>
    </Container>
  );
};

export default ServiceAicc;
